import { get, post, patch, remove } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  state: {
    documents: []
  },

  getters: {},

  mutations: {
    retrievedDocuments: (state, documents) => {
      state.documents = documents;
    },

    addDocument: (state, document) => {
      state.documents.push(document);
    },

    updateDocument: (state, document) => {
      state.documents = state.documents.map(item => {
        if (item.id === document.id) {
          return Object.assign({}, item, document);
        }
        return item;
      });
    }
  },

  actions: {
    retrieveDocuments: () => get('/documents/not-administrative-list'),

    retrieveDocument: (_, document) => get(`/documents/edit/${document}`),

    retrieveTypes: () => get('/documents/types'),

    retrieveTypesAdministrative: () => get('/documents/types-administrative'),

    storeDocument: ({ commit }, document) => {
      return post('/documents', document).then(response => {
        commit('addDocument', response);
        return response;
      });
    },

    updateDocument: ({ commit }, { documentId, document }) => {
      return patch(`/documents/${documentId}`, document).then(response => {
        commit('updateDocument', response);
        return response;
      });
    },

    remove: (_, data) => remove(`/documents/${data.document_id}`),

    retrieveDocumentsForBuilding: (_, idBuilding) =>
      get(`/file-list-for-building/${idBuilding}`),

    addDocumentForBuilding: (_, data) =>
      post('/attach-document-building', data),

    removeDocumentForBuilding: (_, data) =>
      post('/detach-document-building', data),

    retrieveDocumentsForPerson: (_, idPerson) =>
      get(`/file-list-for-person/${idPerson}`),

    addDocumentForPerson: (_, data) => post('/attach-document-person', data),
    removeDocumentForPerson: (_, data) => post('/detach-document-person', data)
  }
};
